<template>
  <!-- Content -->
  <div class="active-chat">
    <div class="todo-app-list">
      <div class="custom-search d-flex justify-content-end">
        <b-form-group class="m-0 p-2">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            @click="createMenu"
          >
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-form-group>
      </div>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group label="Tên menu" label-for="name">
              <b-form-input
                id="name"
                v-model="infoMenu.name"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Nhập tên"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Route"
            rules="required"
          >
            <b-form-group label="Route" label-for="route">
              <b-form-input
                id="route"
                v-model="infoMenu.path"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Nhập route"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- <validation-provider
            #default="validationContext"
            name="Action"
            rules="required"
          >
            <b-form-group label="Action" label-for="action">
              <b-form-input
                id="action"
                v-model="infoMenu.action"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Nhập action"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <validation-provider
            #default="validationContext"
            name="Icon"
            rules=""
          >
            <b-form-group label="Icon" label-for="icon">
              <b-form-input
                id="name"
                v-model="infoMenu.icon"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Icon"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Sort"
            rules="required"
          >
            <b-form-group label="Sort" label-for="sort">
              <b-form-input
                id="sort"
                v-model="infoMenu.sort"
                :state="getValidationState(validationContext)"
                type="number"
                placeholder="Sort"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group label="Menu cha" label-for="menu_cha">
            <treeselect
              v-on:select="format"
              :options="treeMenu"
              value-format="id"
              v-model="infoMenu.parentId"
              :searchable="true"
              :show-count="true"
              :default-expand-level="1"
              :normalizer="normalizer"
              placeholder="Chọn menu"
            />
          </b-form-group>

          <div class="d-flex mt-2 justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Lưu
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="handleDelete"
              :disabled="!infoMenu.id"
            >
              Xóa
            </b-button>
          </div>
        </b-form>
      </validation-observer>
      <!-- </vue-perfect-scrollbar> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import store from "@/store";
import { ref, watch } from "@vue/composition-api";
import {
  BAvatar,
  BForm,
  BFormCheckbox,
  BInputGroup,
  BFormGroup,
  BInputGroupPrepend,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import { required, alphaNum, email } from "@validations";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import draggable from "vuedraggable";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  MenuCreate,
  MenuUpdate,
  MenuDelete,
} from "@/services/api/DefaultTemplate/MenuService";

export default {
  components: {
    draggable,
    // BSV
    BAvatar,
    BForm,
    BFormCheckbox,
    BInputGroup,
    BFormGroup,
    BInputGroupPrepend,
    BFormInput,
    BFormInvalidFeedback,
    ValidationObserver,
    ValidationProvider,
    VuePerfectScrollbar,
    BButton,
    Treeselect,
  },
  directives: {
    Ripple,
  },
  props: {
    dataMenu: {
      type: Object,
      required: true,
    },
    treeMenu: {
      type: Array,
    },
  },
  data() {
    return {
      required,
      infoMenu: {},
    };
  },
  watch: {
    dataMenu() {
      // console.log("dataMenu", this.dataMenu);
      this.infoMenu = JSON.parse(JSON.stringify(this.dataMenu));
    },
  },
  methods: {
    format(node, instanceId) {
      // this.model.chuDauTu = {id: node.id, ten: node.label};
    },
    normalizer(node) {
      // console.log(node);

      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    createMenu() {
      this.infoMenu = {};
    },
    async handleDelete() {
      if (this.infoMenu.id && this.infoMenu.id != "") {
        var res = await MenuDelete(this.infoMenu.id);
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.$emit("reload");
          this.infoMenu = {};
        }
      }
    },
    async onSubmit() {
      // if (this.isWait) {
      //     this.$toast({
      //         component: ToastificationContent,
      //         position: 'top-right',
      //         props: {
      //             title: 'Notification',
      //             icon: 'CoffeeIcon',
      //             variant: 'info',
      //             text: 'In Progress',
      //         },
      //     })
      // }
      // else {
      console.log("dataMEnu", this.infoMenu);
      if (this.infoMenu.id && this.infoMenu.id != "") {
        //Update
        var res = await MenuUpdate(this.infoMenu);
        // this.isWait = false;
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.$emit("reload");
          this.infoMenu = {};
        }
      } else {
        //Add
        var res = await MenuCreate(this.infoMenu);
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.$emit("reload");
        }
      }
      // }
    },
  },

  setup(props, { emit }) {
    // const curItems = ref([]);
    // const rootItems = ref([]);
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    // const searchQuery = ref("");
    // const filter = (val) => {
    //   if (val.trim() == "") {
    //     curItems.value = JSON.parse(JSON.stringify(rootItems.value));
    //   } else {
    //     const searchFilterFunction = function (item) {
    //       return item
    //         ? item.name.toLowerCase().includes(val.toLowerCase()) ||
    //             item.code.toLowerCase().includes(val.toLowerCase())
    //         : false;
    //     };
    //     curItems.value = rootItems.value.filter(searchFilterFunction);
    //   }
    // };

    // const checkItem = (item) => {
    //   var index = rootItems.value.findIndex((el) => el.id == item.id);
    //   if (index != -1) {
    //     rootItems.value[index].isCheck = item.isCheck;
    //   }
    //   emit("add-moduleid", item.id);
    // };
    // const unCheckItem = (item) => {
    //   var index = rootItems.value.findIndex((el) => el.id == item.id);
    //   if (index != -1) {
    //     rootItems.value[index].isCheck = item.isCheck;
    //   }
    //   emit("delete-moduleid", item.id);
    // };
    const { refFormObserver, getValidationState, resetForm } = formValidation(
      () => {
        //Reset form
      }
    );

    return {
      // curItems,
      // rootItems,
      // searchQuery,
      // filter,
      // checkItem,
      // unCheckItem,
      refFormObserver,
      getValidationState,
      resetForm,
      perfectScrollbarSettings,
    };
  },
};
</script>

<style lang="scss" scoped>
.draggable-task-handle {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  cursor: move;

  .todo-task-list .todo-item:hover & {
    visibility: visible;
  }
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
